// Contact Configuration
export const CONTACT_CONFIG = {
  // Main toggle for contact functionality
  enableContactInfo: true,
  
  // Contact display settings
  display: {
    showContactSection: true,    // Show entire contact section
    showVisitClinic: true,       // Show "Visit Our Clinic" section
    showAddress: true,           // Show address information
    showPhone: true,             // Show phone numbers
    showEmail: true,             // Show email addresses
    showHours: true,             // Show opening hours
    showMap: true,               // Show map placeholder
    showContactForm: true,       // Show contact form
    showEmergencyInfo: true,     // Show emergency contact info
    showSocialLinks: true       // Show social media links (for future use)
  },
  
  // Contact information customization
  contactInfo: {
    clinicName: "Sravani Ayurdham",
    address: {
      street: "",
      city: "",
      country: "India"
    },
    phone: {
      primary: "+91 ",
      secondary: "+91 "
    },
    email: {
      info: "info@sravaniayurdham.com",
      appointments: "appointments@sravaniayurdham.com"
    },
    hours: {
      weekdays: "Monday - Saturday: 9:00 AM - 7:00 PM",
      weekend: "Sunday: 10:00 AM - 5:00 PM",
      emergency: "Emergency: 24/7 Available"
    },
    social: {
      instagram: "https://instagram.com/sravani_ayurdham",
      youtube: "https://youtube.com/@sravaniayurdham"
    }
  },
  
  // Alternative content when contact info is disabled
  alternative: {
    showMessage: true,
    message: "Contact information is currently being updated. Please check back soon.",
    showEmergencyOnly: true,
    emergencyContact: "+91 "
  }
};

// Helper function to check if contact info is enabled
export const isContactInfoEnabled = () => {
  return CONTACT_CONFIG.enableContactInfo;
};

// Helper function to check if specific contact features should show
export const shouldShowContactFeature = (feature) => {
  if (!CONTACT_CONFIG.enableContactInfo) return false;
  return CONTACT_CONFIG.display[feature] || false;
};

// Helper function to get contact information
export const getContactInfo = (type, subtype = null) => {
  if (subtype) {
    return CONTACT_CONFIG.contactInfo[type]?.[subtype] || '';
  }
  return CONTACT_CONFIG.contactInfo[type] || '';
};

// Helper function to get alternative message when contact info is disabled
export const getContactAlternativeMessage = () => {
  return CONTACT_CONFIG.alternative;
};

// Helper function to check if any contact info should be shown
export const shouldShowAnyContactInfo = () => {
  if (!CONTACT_CONFIG.enableContactInfo) return false;
  const displaySettings = CONTACT_CONFIG.display;
  return Object.keys(displaySettings).some(key => displaySettings[key]);
};

// Helper function to get all social links
export const getSocialLinks = () => {
  return CONTACT_CONFIG.contactInfo.social;
};

// Helper function to check if social links are enabled and available
export const hasSocialLinks = () => {
  return CONTACT_CONFIG.enableContactInfo && 
         CONTACT_CONFIG.display.showSocialLinks && 
         Object.keys(CONTACT_CONFIG.contactInfo.social).length > 0;
};
